import { render, staticRenderFns } from "./_PHONES.vue?vue&type=template&id=3ac6604c&"
import script from "./_PHONES.vue?vue&type=script&lang=js&"
export * from "./_PHONES.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports